// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607060221/js/" + chunkId + "." + {"44":"896164b4","225":"e64de372","481":"29269795","486":"b3e7e293","770":"eb94711e"}[chunkId] + ".0.4835517292882129.chunk.js";
};